<div
  class="modal-window"
  [class.small-modal]="config.size === 'small'"
  [class.medium-modal]="config.size === 'medium'"
  [class.giant-modal]="config.size === 'giant'"
  [class.big-modal]="config.size === 'big'"
  [class.flex-modal]="config.size === 'flex'"
>
  @if (config.titleTemplate) {
    <div class="modal-title dt-dark-theme">
      <div class="modal-title-text">
        <h4 class="mat-subtitle-2"><ng-container [ngTemplateOutlet]="config.titleTemplate"></ng-container></h4>
        <div class="mat-caption"><ng-container [ngTemplateOutlet]="config.subTitleTemplate"></ng-container></div>
      </div>
      <div>
        <ng-container [ngTemplateOutlet]="config.actionsTemplate"></ng-container>
        @if (config.showX) {
          <button mat-icon-button (click)="close()" data-cy="dt-modal-title-close"><mat-icon>close</mat-icon></button>
        }
      </div>
    </div>
  }
  @if (config.subHeaderTemplate) {
    <div class="modal-subheader">
      <ng-container [ngTemplateOutlet]="config.subHeaderTemplate"></ng-container>
    </div>
  }
  @if (config.contentTemplate) {
    <div class="modal-content" [class.content-padding]="config.contentPadding" [class.flex-content]="config.flexContent">
      <ng-container [ngTemplateOutlet]="config.contentTemplate"></ng-container>
    </div>
  }
  @if (config.showFooter) {
    <mat-divider></mat-divider>
    <div class="modal-footer">
      <div class="modal-footer-content">
        <ng-container [ngTemplateOutlet]="config.footerTemplate"></ng-container>
      </div>
      @if (!config.footerTemplate) {
        <button mat-raised-button color="accent-less" (click)="close()" i18n>Schließen</button>
      }
    </div>
  }
</div>
